export const L10N = {
  LABEL_CARD_NAME: { id: 'core.label.card_name' },
};
